import { createRouter, createWebHistory } from 'vue-router'
import Index from '@/pages/Index.vue'
import Home from '@/pages/Home.vue'
import Acceptnotification from '@/pages/Acceptnotification.vue'
import Login from '@/pages/Login.vue'
import Register from '@/pages/Register.vue'
import Updateavailable from '@/pages/Updateavailable.vue'
import Welcome from '@/pages/Welcome.vue'
import Orders from '@/pages/Orders.vue'
import Products from '@/pages/Products.vue'
import Payments from '@/pages/Payments.vue'
import Customers from '@/pages/Customers.vue'
import Riders from '@/pages/Riders.vue'
import Chat from '@/pages/Chat.vue'
import Preferences from '@/pages/Preferences.vue'
import ProSubscription from '@/pages/ProSubscription.vue'
import AccountValidation from '@/pages/AccountValidation.vue'
import DailyDeals from '@/pages/DailyDeals.vue'
import WithdrawalaccountsBank from '@/components/withdrawal/WithdrawalaccountsBank.vue'
import WithdrawalaccountsMomo from '@/components/withdrawal/WithdrawalaccountsMomo.vue'
import TopProducts from '@/pages/TopProducts.vue'
import Chargebacks from '@/pages/Chargebacks.vue'
import DeliveryLocations from '@/pages/DeliveryLocations.vue'
import PlatformAccessSubscription from '@/components/platformAccess/PlatformAccessSubscription.vue'
// import ProductsView from '@/views/ProductsView.vue'
// import ProductDetails from '@/views/ProductDetails.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
    },
    {
      path: '/payments',
      name: 'payments',
      component: Payments,
    },
    {
      path: '/chargebacks',
      name: 'chargebacks',
      component: Chargebacks,
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers,
    },
    {
      path: '/riders',
      name: 'riders',
      component: Riders,
    },
    {
      path: '/deliveryLocations',
      name: 'deliveryLocations',
      component: DeliveryLocations,
    },
    {
      path: '/deals',
      name: 'deals',
      component: DailyDeals,
    },
    {
      path: '/promotion',
      name: 'promotion',
      component: TopProducts,
    },
    {
      path: '/chat',
      name: 'chat',
      component: Chat,
    },
    {
      path: '/preferences',
      name: 'preferences',
      component: Preferences,
    },
    {
      path: '/acceptnotification',
      name: 'acceptnotification',
      component: Acceptnotification,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/updateavailable',
      name: 'updateavailable',
      component: Updateavailable,
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome,
    },
    {
      path: '/googleLogin/done',
      name: 'googleLoginDone',
      component: Welcome,
    },
    {
      path: '/validation',
      name: 'accountValidation',
      component: AccountValidation,
    },
    {
      path: '/pro',
      name: 'proSubscription',
      component: PlatformAccessSubscription,
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: WithdrawalaccountsBank,
    },
    {
      path: '/transfer',
      name: 'transfer',
      component: WithdrawalaccountsMomo,
    },
    // { path: '/category/:categoryId', component: ProductsView },
    // { path: '/product/:productId', component: ProductDetails },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (About.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import('../views/AboutView.vue'),
    // },
  ],
  scrollBehavior(to, from, savedPosition) {
    // console.log(to)
    // always scroll to top
    return { top: 0 }
  },
})

export default router
